import {jQuery as $, lodash as _} from 'lib/shim';



export function generateObjectFitCallback(config){
	$.assert($.hasMembers(config, ['callbackHandler', '$element', 'containerSelector']), 'generateObjectFitCallback | missing config (callbackHandler, $element or containerSelector)');

	let callbackHandler = config.callbackHandler,
		$element = config.$element,
		containerSelector = ''+config.containerSelector,
		$container = $element.closest(containerSelector),
		positioningSelector = $.isSet(config.positioningSelector) ? ''+config.positioningSelector : null,
		$positioningElement = $.isSet(positioningSelector) ? $element.closest(positioningSelector) : $element,
		containerWidth = null,
		containerHeight = null,
		containerAr = null,
		elementWidth = null,
		elementHeight = null,
		elementAr = null,
		elementFits = false,
		elementPosition = $.isSet(config.position) ? config.position : {'top' : '50%', 'left' : '50%'};

	$element.css({
		'max-width' : 'none',
		'max-height' : 'none'
	});

	$positioningElement
		.css($.extend({
			'position' : 'absolute',
			'max-width' : 'none',
			'max-height' : 'none',
		}, elementPosition))
	;

	if(
		((elementPosition.top === '50%') || (elementPosition.bottom === '50%'))
		&& ((elementPosition.left === '50%') || (elementPosition.right === '50%'))
	){
		$positioningElement.cssCrossBrowser({
			'transform' : 'translate(-50%, -50%)'
		});
	} else if( (elementPosition.top === '50%') || (elementPosition.bottom === '50%') ){
		$positioningElement.cssCrossBrowser({
			'transform' : 'translateY(-50%)'
		});
	} else if( (elementPosition.left === '50%') || (elementPosition.right === '50%') ){
		$positioningElement.cssCrossBrowser({
			'transform' : 'translateX(-50%)'
		});
	}

	return callbackHandler(function(){
		elementWidth = $element.outerWidth();
		elementHeight = $element.outerHeight();

		containerWidth = $container.outerWidth();
		containerHeight = $container.outerHeight();

		elementFits = (
			(elementWidth === containerWidth)
			&& (elementHeight >= containerHeight)
		) || (
			(elementHeight === containerHeight)
			&& (elementWidth >= containerWidth)
		);


		if( !elementFits ){
			containerAr = containerWidth / containerHeight;
			elementAr = elementWidth / elementHeight;

			if( elementAr >= containerAr ){
				$element.css({
					'width' : '',
					'height' : containerHeight
				});
			} else {
				$element.css({
					'width' : containerWidth,
					'height' : ''
				});
			}
		}
	});
}
